import { addLocale, locale } from "primereact/api";

export const PRIME_REACT_FIRST_DAY_OF_WEEK = 1;

const primeReactLocales = {
    nl: {
        firstDayOfWeek: PRIME_REACT_FIRST_DAY_OF_WEEK,
        dayNames: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
        dayNamesShort: ["zo", "ma", "di", "wo", "do", "vr", "za"],
        dayNamesMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
        monthNames: [
            "januari", "februari", "maart", "april", "mei", "juni",
            "juli", "augustus", "september", "oktober", "november", "december",
        ],
        monthNamesShort: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
        today: "Vandaag",
        clear: "Wissen",
    },
    en: {
        firstDayOfWeek: PRIME_REACT_FIRST_DAY_OF_WEEK,
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December",
        ],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        today: "Today",
        clear: "Clear",
    },
};

let localesRegistered = false;

const registerPrimeReactLocales = () => {
    if (localesRegistered) {
        return;
    }
    addLocale("nl", { ...primeReactLocales.nl });
    addLocale("en", { ...primeReactLocales.en });
    localesRegistered = true;
};

export const primeReactLocaleCode = (languageCode?: string | null): "nl" | "en" =>
    `${languageCode || ""}`.toLowerCase().startsWith("en") ? "en" : "nl";

export const applyPrimeReactLocale = (languageCode?: string | null): "nl" | "en" => {
    registerPrimeReactLocales();
    const nextLocale = primeReactLocaleCode(languageCode);
    locale(nextLocale);
    return nextLocale;
};
